export default function isDocumentElement(element: HTMLElement) {
    return element === document.documentElement || element instanceof Document
}
